import Typography from "@mui/material/Typography"
import { Invoice, InvoicePaymentStatusEnum } from "@sb1finans/new-api/dist/api";
import React from "react";
import Stack from "@mui/material/Stack"
import styled from "@emotion/styled"
import { formatDate } from "../utils/formatters";


interface AccountInvoicesProps {
    invoices?: Invoice[]
}

const InvoiceCard = styled(Stack)`
    background-color: #efefef;
`

export const AccountInvoices: React.FC<AccountInvoicesProps> = ({invoices = []}) => {
    return (
        <Stack spacing={2} maxWidth={600} margin="0 auto">
            { /*error && <Alert severity="error">En feil oppstod ved henting av fakturaer.</Alert> */ }
            { /* loading && <Typography variant="body1">Laster fakturaer...</Typography> */ }
            <Typography variant="h5">Forfalte</Typography>
            {invoices.filter(invoice => invoice.paymentStatus === InvoicePaymentStatusEnum.Expired).map(invoice => (
                <InvoiceEntity key={invoice.invoiceId ?? `${invoice.cid}-${invoice.invoiceNo}`} {...invoice} />
            ))}
            <Typography variant="h5">Til inkasso</Typography>
            {invoices.filter(invoice => invoice.paymentStatus === InvoicePaymentStatusEnum.InCollection).map(invoice => (
                <InvoiceEntity key={invoice.invoiceId ?? `${invoice.cid}-${invoice.invoiceNo}`} {...invoice} />
            ))}
            <Typography variant="h5">Til forfall</Typography>
            { invoices.filter(invoice => invoice.paymentStatus === InvoicePaymentStatusEnum.Open).map(invoice => (
                <InvoiceEntity key={invoice.invoiceId ?? `${invoice.cid}-${invoice.invoiceNo}`} {...invoice} />
            ))}
            <Typography variant="h5">Betalte</Typography>
            { invoices
                .filter(invoice => invoice.paymentStatus === InvoicePaymentStatusEnum.Paid)
                .map(invoice => (
                    <InvoiceEntity key={invoice.invoiceId ?? `${invoice.cid}-${invoice.invoiceNo}`} {...invoice} />
            ))}
        </Stack>
    );
}

const InvoiceEntity = (invoice: Invoice) => {
    return (
        <InvoiceCard justifyContent="space-between" spacing={1} padding={2}>
            <Stack direction="row" spacing={2}>
                <Typography variant="body1">Dato:</Typography>
                <Typography variant="body1" alignSelf="right">{formatDate(new Date(invoice.invoiceDate))}</Typography>
            </Stack>
            <Stack direction="row" spacing={2}>
                <Typography variant="body1">KID:</Typography>
                <Typography variant="body1">{invoice.cid}</Typography>
            </Stack>
            <Stack direction="row" spacing={2}>
                <Typography variant="body1">Dato:</Typography>
                <Typography variant="body1">{formatDate(new Date(invoice.dueDate))}</Typography>
            </Stack>
            <Stack direction="row" spacing={2}>
                <Typography variant="body1">Beløp:</Typography>
                <Typography variant="body1">{invoice.totalAmount}</Typography>
            </Stack>
            <Stack direction="row" spacing={2}>
                <Typography variant="body1">Kontonummer:</Typography>
                <Typography variant="body1">{"4201.07.00064"}</Typography>
            </Stack>
        </InvoiceCard>
    )
}